import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService , AdobeAnalyticsService} from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';

import { ANALYTICS_CONSTANTS } from 'config';



@Injectable()
export class FaqService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService,
     private adobeAnalyticsService: AdobeAnalyticsService) { }

  handleError = (error) => {
    return throwError(error);
  }


  getFaqDetails() {
    let headers = new HttpHeaders();
  //  headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    if (this.utilityService.getEnvConfig().useMock) {
    return this.httpClientService.get(this.utilityService.getEnvConfig().faqServiceUrlMock)
    // headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
   }else {
    return this.httpClientService.get(this.utilityService.getEnvConfig().faqServiceUrl)
    //headers)
    .pipe(
       map((res: HttpResponse<any>) => {
      this.httpClientService.updateAuthorizationHeaders(res);
      return res.body;
    }
    )
    ,catchError( this.handleError ));

   }
   }
   createPageLoadProperties() {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_FAQ;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SUPPORT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Support';

    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';

    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}
